import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'
import { EduIf, WithResources } from '@edulastic/common'
import { Spin } from 'antd'
import { compose } from 'redux'
import { connect } from 'react-redux'
import AppConfig from '../../../../../app-config'
import CalculatorsWithTab from './components/CalculatorsWithTab'
import { fetchDesmosConfigAction } from '../../../sagas/desmos'

const CalculatorsWithResources = ({
  calcProvider,
  calcTypes,
  changeTool,
  fetchDesmosConfig,
}) => {
  useEffect(() => {
    fetchDesmosConfig()
  }, [])

  return (
    <EduIf condition={!isEmpty(calcTypes)}>
      {() => (
        <WithResources
          resources={[
            AppConfig.desmosPath,
            AppConfig.matrixCalculatorPath,
            AppConfig.geoGebraPath,
            AppConfig.jqueryPath,
            AppConfig.eduScientificCalcJsPath,
            AppConfig.eduScientificCalcCssPath,
          ]}
          fallBack={<Spin />}
        >
          <CalculatorsWithTab
            calcProvider={calcProvider}
            calcTypes={calcTypes}
            changeTool={changeTool}
          />
        </WithResources>
      )}
    </EduIf>
  )
}

CalculatorsWithResources.propTypes = {
  calcProvider: PropTypes.string.isRequired,
  calcTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  changeTool: PropTypes.func.isRequired,
}

const enhance = compose(
  connect(() => ({}), {
    fetchDesmosConfig: fetchDesmosConfigAction,
  })
)

export default enhance(CalculatorsWithResources)
